exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/deep/ .modal-backdrop + .modal-backdrop {\n  z-index: 1051; }\n\n/deep/ .modal-backdrop:nth-child(2n-1) {\n  opacity: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/app/login-signup-modal/login-signup-modal.component.scss
// module id = ../../../../../src/app/login-signup-modal/login-signup-modal.component.scss
// module chunks = main